import React from 'react';
import { Box, Typography } from '@mui/material';
import InnerTopBar from '../../components/layout/InnerTopBar';

const HistoryScreen = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', flex: 1 }}>
            <InnerTopBar title="History" />
            <Box sx={{ p: 2 }}>
                <Typography variant="h6">History of Sent Reminders</Typography>
                {/* Here you can add the logic to display the history of sent reminders */}
            </Box>
        </Box>
    );
};

export default HistoryScreen;